import { occupancyMapping } from '../../utils/OccupancyMapping';

export interface TableProps {
  openFlyout: boolean;
  toggleDrawer: Function;
  updateFilters: Function;
  toggleSearchDrawer?: Function;
  onDataStatusChange?: Function;
}

export interface ValidationReviewInventoryTableFields {
  recordId: string;
  portfolioIds: string[];
  applicationRequestReceiptDate: string;
  portfolioEpipProcessingStatus: string;
  applicationId: number;
  pirfFile: PirfFileType;
  insuredApprovedLenderCode: string;
  insuredApprovedLenderName: InsuredApprovedLenderName;
  portfolioPoolPrecisionTypeCode: string;
  portfolioOccupancyType: keyof typeof occupancyMapping;
  portfolioTermInsurance: number;
  portfolioNumberOfLoansSubmitted: number;
  portfolioAmountSubmitted: number;
}

export type FilterDropDownOptionsType = {
  requestType: string[];
  status: string[];
  year: string[];
  insuredApprovedLenderName: string[];
};

export type LenderOptionType = {
  approvedLenderEnglishName: string;
  approvedLenderFrenchName: string;
  lenderCode: string;
};

export type FormErrors = {
  toDate?: boolean;
  fromDate?: boolean;
  dateRange?: string;
};

export type InsuredApprovedLenderName = {
  englishName: string;
  frenchName: string;
};

export type PirfFileType = {
  name: string;
  fileId: string;
};

export enum LoanStatusCode {
  RECEIVED = '01',
  PASSED = '02',
  FAILED = '03',
  REVIEW_REQUIRED = '04',
  DELETED = '09'
}

export enum EpipProcessingStatusCode {
  RECEIVED = '01',
  VALIDATION_IN_PROGRESS = '02',
  VALIDATION_COMPLETED = '03',
  READY_FOR_CREDIT_BUREAU = '04',
  FILE_READY_FOR_CREDIT_BUREAU = '05',
  SENT_TO_CREDIT_BUREAU = '06',
  RECEIVED_FROM_CREDIT_BUREAU = '07',
  SENT_TO_EPIP = '08',
  DELETED = '09',
  MANUAL = '10',
  READY_TO_CANCEL = '11',
  CANCELLATION_COMPLETED = '12'
}
